module.exports = __webpack_public_path__ + "static/media/application.9adbca72.png";